export default __webpack_public_path__ + "static/media/9.f2e23309.jpg";